import { nxtReCaptcha } from '@nxtpeople/nxt-styles';
import { getKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { toRem } from '@nxtpeople/nxt-vue-library';
import dayjs from 'dayjs';
import type { App } from 'vue';
import { checkAccess, checkAddon } from '../helpers/auth.helper';
import { formatPerformanceCode } from '../helpers/formatters';

export default {
   install(app: App) {
      app.config.globalProperties.$dayjs = dayjs;
      app.config.globalProperties.$auth = checkAccess;
      app.config.globalProperties.$addon = checkAddon;
      app.config.globalProperties.$keycloak = getKeycloak();
      app.config.globalProperties.$toRem = (x: number) => toRem(x, 13);
      app.config.globalProperties.$formatPerformanceCode = formatPerformanceCode;

      // Expose ReCaptcha options installer convenience (kept here if needed elsewhere)
      app.use(nxtReCaptcha, {
         siteKeyV3: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY_V3,
         siteKeyV2: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY_V2,
      });
   },
};
